import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetStudents = () => {
    const {
        isLoading, data: students, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: ["students"],
        queryFn: () => axiosManager.get$("/parent/api/Students").then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        keepPreviousData: true,
        select: (data) => data?.map((item) => ({ ...item, fullName: `${item.forename} ${item.surname}` })),
    });

    return {
        isLoading,
        isRefetching,
        students: students || [],
        error,
        refetch,
    };
};
